import styled from "styled-components";

export const WithdrawalVerificationContainer = styled.section`
  h2 {
    margin-bottom: 0px !important;
    color: #414651;
    font-size: 14px;
    font-weight: 500;
    font-family: "Geist", sans-serif;
  }

  .divider {
    border-top: 1px solid ${({ theme }) => theme.menu.divider};
  }

  .switch-wrapper {
    display: flex;
    align-items: center;
    gap: 32px;
    margin-bottom: 25px;

    span {
      color: #535862;
      font-size: 14px;
      font-weight: 400;
    }
    .text-message-inner-wrapper p {
      font-size: 14px;
      font-weight: 500;
      font-family: "Geist", sans-serif;
      color: #414651;
    }
    .text-message-wrapper {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1;
    }
    .heading-wrapper {
      flex: 1;
    }

    .secondary {
      label {
        width: 46px;
        height: 26px;
      }

      .slider {
        background-color: ${({ theme }) => theme.switch.bg.primary} !important;

        &:before {
          background-color: ${({ theme }) => theme.switch.bg.secondary};
          height: 20px;
          width: 20px;
          left: 3px;
          top: 3px;
          bottom: 0px;
        }
      }

      input:checked + .slider {
        background-color: ${({ theme }) => theme.button.bg.primary} !important;
      }

      input:checked + .slider:before {
        -webkit-transform: translateX(20px);
        -ms-transform: translateX(20px);
        transform: translateX(20px);
      }
    }
  }

  /* Shown only while confirming a switch-off. */
  .step-up-wrapper {
    margin-bottom: 24px;

    .step-up-prompt {
      color: #535862;
      font-size: 13px;
      font-weight: 400;
      margin-bottom: 8px;
    }

    .step-up-form {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      flex-wrap: wrap;
    }

    .code-input {
      max-width: 160px;
    }

    .form-error {
      margin-top: 4px;
    }

    .step-up-actions {
      display: flex;
      align-items: center;
      gap: 8px;
      padding-top: 22px;
    }
  }

  .no-phone-hint {
    color: #535862;
    font-size: 13px;
    margin-bottom: 24px;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 18px;
    }

    .switch-wrapper {
      flex-direction: column;
    }

    .step-up-wrapper .code-input {
      max-width: 100%;
    }
  }
`;
